var $ = require('jQuery');
var MergeFields = require('../../lib/merge-fields.js');

module.exports = function() {
    var hideUnused = function() {
        var type = $("input[name='recipientOption']:checked").val();

        if (type === 'user') {
            $('#notification-recipient-recipients').hide().val('');
            $('#notification-recipient-field').hide().val('');
        }

        if (type === 'field') {
            $('#notification-recipient-field').show();
            $('#notification-recipient-recipients').hide().val('');
        }

        if (type === 'recipients') {
            $('#notification-recipient-recipients').show();
            $('#notification-recipient-field').hide().val('');
        }
    };

    var displayRecipients = function () {
        var recipientOptionTriggers = ['entry.submitted', 'entry.resubmitted', 'entry.moderated', 'entry.tagged'];

        if (recipientOptionTriggers.indexOf($('#trigger').val()) !== -1) {
            $('.notification-recipient-option-field').show();
        } else {
            $('.notification-recipient-option-field').hide();
        }

        hideUnused();
    };

    var displayMergeFields = function () {
        var trigger = $("#trigger").val().replace(/\./g, '_');

        $("[id$=-merge-fields]").attr('class', 'hidden');
        $("[id^=" + trigger + "]").toggleClass('hidden');
    };

    var displayRoleSelector = function () {
        if ($('#trigger').val() === 'role.granted') {
            $('#role-selector').show();
        } else {
            $('#role-selector').hide();
        }

        if ($('#select-roles').prop('checked')) {
            $('#role-multiselect').show();
        } else {
            $('#role-multiselect').hide();
        }
    };

    var displayModeratedSelector = function () {
        if ($('#trigger').val() === 'entry.moderated') {
            $('#moderation-options').show();
        } else {
            $('#moderation-options').hide();
        }
    };

    var displayTagsInput = function () {
        if ($('#trigger').val() === 'entry.tagged') {
            $('#tags-input').show().find('input').attr('disabled', false);
        } else {
            $('#tags-input').hide().find('input').attr('disabled', true);
        }
    };

    var displayLegalBasisSelector = function () {

        const systemNotifications = ['user.registered', 'role.granted'];
        if (systemNotifications.indexOf($('#trigger').val()) !== -1) {
            $('#legalBasisGroup').hide();
        } else {
            $('#legalBasisGroup').show();
        }
    };

    var mergeFields = new MergeFields();

    mergeFields.setup('merge-fields', 'input[id="subject"],textarea[id="body"],textarea[id="smsBody"]');

    $("#trigger").on('change', displayRecipients)
                 .on('change', displayMergeFields)
                 .on('change', displayRoleSelector)
                 .on('change', displayTagsInput)
                 .on('change', displayModeratedSelector)
                 .on('change', displayLegalBasisSelector);

    $('#all-roles, #select-roles').on('change', displayRoleSelector);
    $("input[name='recipientOption']").on('change', hideUnused);

    displayRecipients();
    displayMergeFields();
    displayRoleSelector();
    displayTagsInput();
    displayModeratedSelector();
    displayLegalBasisSelector();
};
